module.exports = __webpack_public_path__ + "cbe2a820f6ad10f8ec5b57f41f3e5720.glb";